module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_Black-f63a495dd53a5e5c3d3169af8d4fe530.png";